import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL

class CommentsService {
  getAllComments(feedbackId) {
    return axios.get(API_URL + 'FeedbackComment?FeedbackId=' + feedbackId)
  }
  postNewComments(commentModel) {
    return axios.post(API_URL + '/FeedbackComment', commentModel)
  }
}

export default new CommentsService()
